<!--
 * @Author: your name
 * @Date: 2021-06-25 17:01:55
 * @LastEditTime: 2021-06-25 17:22:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/@core/layouts/layout-vertical/components/vertical-nav-menu/components/vertical-nav-menu-link/VerticalNavMenuLink.vue
-->
<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      class="d-flex align-items-center"
      @click="linkClick(item)"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
      />
      <span class="menu-title text-truncate">{{ item.title }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    linkClick(item) {
      if (this.$route.path !== item.route) {
        this.$router.push({
          path: this.$router.$avueRouter.getPath({
            name: item.title,
            src: item.route,
          }),
        });
      } else {
        this.$router.push({
          path: this.$route.fullPath, // 获取当前连接，重新跳转
          query: {
            _time: new Date().getTime() / 1000, // 时间戳，刷新当前router
          },
        })
      }
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
<style lang="scss" scoped>
.nav-item.has-sub .nav-item.has-sub li svg{
  display: block;
  margin-right: 0.8rem !important;
}
</style>
